import { render } from "./tapTop.vue?vue&type=template&id=22a9e6e2"
import script from "./tapTop.vue?vue&type=script&lang=js"
export * from "./tapTop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__